import { DataFieldRef } from '@chilipiper/api-client/src/chat-platform-chat'
import { type DefaultDataFieldId } from '@chilipiper/api-client/src/chili-crm'

const DATAFIELD_TYPES = {
  PersonEmail: 'PersonEmail',
  PersonState: 'PersonState',
  CompanyName: 'CompanyName',
  PersonLastName: 'PersonLastName',
  PersonFirstName: 'PersonFirstName',
} as Record<string, DefaultDataFieldId>

export const mapDatafieldTypeToAutoComplete = (dataFieldRef: DataFieldRef) => {
  switch (dataFieldRef) {
    case DATAFIELD_TYPES.PersonEmail:
      return 'email'
    case DATAFIELD_TYPES.PersonFirstName:
      return 'given-name'
    case DATAFIELD_TYPES.PersonLastName:
      return 'family-name'
    case DATAFIELD_TYPES.PersonState:
      return 'address-level1'
    case DATAFIELD_TYPES.CompanyName:
      return 'organization'
    default:
      return 'off'
  }
}
